import { createIdStore } from "@/listings/listing.marks.ts";

/**
 * Which listings this browser has already opened.
 *
 * v1 collected whatever got tapped while the ring was being designed, on a
 * build where the mark meant the opposite of what it means now — so it was a
 * record of testing rather than of reading, and it was hiding listings its owner
 * still wanted to look at. A new key was the whole migration.
 *
 * The cap is roughly a year of heavy use, and about 100 kB. Past some size this
 * stops being a memory of what you've looked at and becomes a tax on every page
 * load, and the ids at the far end are for listings taken down months ago.
 */
const store = createIdStore({
  key: "radar.seen.v2",
  legacyKeys: ["radar.seen.v1"],
  limit: 4000,
  label: "SeenIds",
});

export const useSeenListings = store.use;
export const markSeen = store.add;
export const clearSeen = store.clear;
